import subGroupTemplate from './accountsSubGroup.html'
import { TableGroupController } from '../tableGroupController';
import { TAB_COUNTRY, TAB_CURRENCY, TAB_BANK } from '../../../views/accounts/overview';
import { AccountService } from '../../../services/AccountService';
import { currencyAccounts, byCountySummary, banks, accounts } from '../../../services/arsweb/RoutingPaths';
import { accountCols } from './accountCols';
import { ACCOUNTS_TITLE } from '../../../services/arsweb/TableTitles';
import { EXPORT_TYPE } from '../../export/ExportModalController';
import { CONSOLIDATION_CURRENCY_PARAMS } from '../../../controller/CommonViewController';

/** @ngInject */
export function accountsSubGroupTable() {
    return {
        restrict: 'E',
        scope: {
            consolitationcurrency: '=',
            itemSel: '=',
            tableId: '@',
            mainCurrencies: '=',
            mainCurrenciesPromise: '=',
            parentController: '='
        },
        templateUrl: subGroupTemplate,
        controller: AccountsSubGroupTableController,
        controllerAs: 'accountsGroupTableController'
    };
}

/** @ngInject */
export class AccountsSubGroupTableController extends TableGroupController {

    constructor($scope, userService, arsMainDependencies) {

          super($scope, userService, arsMainDependencies, new AccountService(userService), 'accountsSubGroupTableParams',
              accountCols, accounts, ACCOUNTS_TITLE);

        this.$scope.isSearching = true;
        this.loadGroupData($scope.itemSel);

        this.supportedExports = [EXPORT_TYPE.CSV, EXPORT_TYPE.XLS, EXPORT_TYPE.PDF_ACCOUNT_OVERVIEW];

        // Listen to grouping changes
        $scope.$on('group.change', (e, data) => this.loadGroupData(data)); // loads new grouping

        // Listen to consolidation currency selection change
        $scope.$on('consolidationCurrency.change', (a, args) => {
            this.$scope.consolitationcurrency = args;
            this.loadGroupData($scope.itemSel);
        });
    }

    loadGroupData(item) {
        // ARSWEB-374: 2nd Level of Grouping selection on 1 first level group applied to all first level groups
        if (this.$scope.tableId !== item.tableId && item.consolidationCurrency === this.$scope.consolitationcurrency.code) {
            return;
        }

        if(item.subGrouping === TAB_CURRENCY) {
            this.restUrl = currencyAccounts;
        }else if(item.subGrouping === TAB_COUNTRY) {
            this.restUrl = byCountySummary;
        }else if(item.subGrouping === TAB_BANK) {
            this.restUrl = banks;
        }

        this.dataFilter([item]);
        this.backendService.service.config.params[CONSOLIDATION_CURRENCY_PARAMS] = this.$scope.consolitationcurrency.code;
        this.backendService.service.config.params['date-to'] = this.$rootScope.pickedDate.valueOf();

        this.promise = this.backendService.getUserSummaryData(this.restUrl).then((data) => {
            this.groups = data.accountSummaries;
            this.format();
            this.$scope.isSearching = false;
        });
    }

    filterEvent(params) {
        return params.group.$hideTable && params.parentTableId === this.$scope.tableId;
    }
}
